import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

var SearchForm = /*#__PURE__*/function (_React$Component) {
  function SearchForm(props) {
    var _this;

    _classCallCheck(this, SearchForm);

    _this = _callSuper(this, SearchForm, [props]);
    _this.renderFields = _this.renderFields.bind(_this);
    _this.onValueChange = _this.onValueChange.bind(_this);
    _this.executeSearch = _this.executeSearch.bind(_this);
    _this.state = {
      data: Object.assign({}, props.defaultValues)
    };
    return _this;
  }

  _inherits(SearchForm, _React$Component);

  return _createClass(SearchForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // make sure default value isn't empty
      if (this.props.defaultValues && this.props.defaultValues.searchValue) {
        this.executeSearch();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (this.props.defaultValues && !isEqual(this.props.defaultValues, prevState.data)) {
        var data = this.props.valueOverride ? this.props.defaultValues : Object.assign({}, prevState.data);
        this.setState({
          data: data
        });
      }
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(obj) {
      var data = Object.assign({}, this.state.data, obj);
      this.setState({
        data: data
      }, this.executeSearch);
    }
  }, {
    key: "executeSearch",
    value: function executeSearch() {
      if (this.props.disabled) {
        return;
      }

      var searchParams = Object.assign({}, this.state.data);
      this.props.searchAction(searchParams);
    }
  }, {
    key: "renderFields",
    value: function renderFields() {
      var _this2 = this;

      return React.Children.map(this.props.children, function (child) {
        if (child.type === 'div') {
          return child;
        } else {
          return /*#__PURE__*/React.cloneElement(child, {
            onValueChange: _this2.onValueChange,
            data: _this2.state.data,
            valueChangeDelay: _this2.props.valueChangeDelay,
            disabled: _this2.props.disabled
          });
        }
      }, this);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("form", {
        className: this.props.className,
        role: "form",
        "data-action": "search-wrapper"
      }, this.renderFields());
    }
  }]);
}(React.Component);

_defineProperty(SearchForm, "propTypes", {
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  defaultValues: PropTypes.object,
  searchAction: PropTypes.func.isRequired,
  valueChangeDelay: PropTypes.number,
  valueOverride: PropTypes.bool
});

_defineProperty(SearchForm, "defaultProps", {
  valueOverride: true,
  valueChangeDelay: 500
});

SearchForm.displayName = "SearchForm";
export { SearchForm };